class Accordion extends HTMLElement {
  handleToggle(event) {
    // TODO: Add animations

    // If the accordion only allows a single item to be open at once we close any other open items
    if (this.hasAttribute("data-single-open")) {
      if (event.target.open) {
        this.querySelectorAll("details[open]").forEach((element) => {
          if (element !== event.target) {
            element.removeAttribute("open");
          }
        });
      }
    }
  }

  connectedCallback() {
    this.addEventListener("toggle", this.handleToggle, true);
  }

  disconnectedCallback() {
    this.removeEventListener("toggle", this.handleToggle, true);
  }
}

if (!customElements.get("accordion-group")) {
  customElements.define("accordion-group", Accordion);
}
